import React, {useEffect, useState} from 'react';
import {Carousel, Modal, Button} from 'react-bootstrap';
import axios from 'axios';
import config from '../../config.json';

// Example folder/image data (replace with real data or props as needed)
/*const galleryData = [
  {
    folder: 'Events 2025',
    images: [
      '/img/gallery/events1.jpg',
      '/img/gallery/events2.jpg',
      '/img/gallery/events3.jpg',
    ]
  },
  {
    folder: 'Annual Day',
    images: [
      '/img/gallery/annual1.jpg',
      '/img/gallery/annual2.jpg',
      '/img/gallery/annual3.jpg',
    ]
  },
  {
    folder: 'Sports',
    images: [
      '/img/gallery/sports1.jpg',
      '/img/gallery/sports2.jpg',
      '/img/gallery/sports3.jpg',
    ]
  }
];*/

export default function GalleryViewer() {
  const [showModal, setShowModal] = useState(false);
  const [modalFolderIdx, setModalFolderIdx] = useState(0);
  const [modalImgIdx, setModalImgIdx] = useState(0);
  const [zoomOut, setZoomOut] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [galleryImages, setGalleryImages]=useState([]);

  useEffect(()=>{
    fetchGalleryImages();
  },[])

  // Open modal with zoom-out effect
  const handleImgClick = (folderIdx, imgIdx) => {
    setModalFolderIdx(folderIdx);
    setModalImgIdx(imgIdx);
    setShowModal(true);
    setZoomOut(true);
    setTimeout(() => setZoomOut(false), 350); // reset zoom after animation
  };

  // Navigate left/right in modal
  const handlePrev = () => {
    setZoomOut(true);
    setTimeout(() => {
      setModalImgIdx((prev) => {
        const imgs = galleryImages[modalFolderIdx].fileName;
        return prev === 0 ? imgs.length - 1 : prev - 1;
      });
      setZoomOut(false);
    }, 200);
  };

  const handleNext = () => {
    setZoomOut(true);
    setTimeout(() => {
      setModalImgIdx((prev) => {
        const imgs = galleryImages[modalFolderIdx].fileName;
        return prev === imgs.length - 1 ? 0 : prev + 1;
      });
      setZoomOut(false);
    }, 200);
  };

  const fetchGalleryImages =async()=>{
    try{
        setLoaded(false);
        //console.log("Testing");
        //const session = await Auth.currentSession();
        //const access_token=session.idToken.jwtToken;
        const fileName='images/gallery/';
        const bucketName="images.mduschooled.in";
    await axios.get(`${config.api.invokeURL}/website/gallery?fileName=${fileName}&bucketName=${bucketName}`,{
        headers: {
          //Authorization: access_token,
          'x-api-key': config.api.key
        }}, 
    ).then((response)=>{
        //console.log(response.data);
        processGalleryData(response.data);
        //setGalleryImages(response.data);
       // enqueueSnackbar(response.data.length + " - Project Images are available",{variant:'success'});
        //setLoaded(true);
        //setDispMsg(response.data.length + " - Images are found in your Gallery");
    }).catch((error)=>{
        //console.log(error.message);
        //enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
        setLoaded(true);
        window.scrollTo(0,0);   
        //setDispMsg(error.message);
    })
  }catch(error){
  //console.log(error.message);
    //enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
    setLoaded(true);
    window.scrollTo(0,0);   
    //setDispMsg(error.message);
  }
  }

  const processGalleryData=(item)=>{
    const test=[];
    for(const i in item){
        var testv={};
        testv=item[i];
        testv.length=item[i].fileName.length;
        testv.id=parseInt(i)+1;
        test.push(testv);
        testv={};
    }
    //console.log("testdata :", test);
    setGalleryImages(test);
    setLoaded(true);
    }

  return (
    <div className="container py-4">
      <h2 className="text-center mb-5 fw-bold modern-gallery-title">Photo Gallery</h2>
      <div className="row g-4">
        {galleryImages.map((folder, idx) => (
          <div className="col-12 col-md-6 col-lg-4" key={idx}>
            <div className="card shadow-sm border-0 h-100 modern-gallery-card">
              <div className="card-body">
                <h5 className="card-title text-center mb-3 fw-semibold modern-gallery-folder">{folder.projectName}</h5>
                <h4 className="card-title text-center mb-3 fw-semibold modern-gallery-folder">{folder.projectDate}</h4>
                <Carousel
                  className="modern-gallery-carousel"
                  interval={3500}
                  indicators={folder.fileName.length > 1}
                  controls={folder.fileName.length > 1}
                  fade={true}
                >
                  {folder.fileName.map((img, imgIdx) => (
                    <Carousel.Item key={imgIdx}>
                      <img
                        src={`${config.s3.imageUrl}${img}`}
                        className="d-block w-100 modern-gallery-img"
                        alt={folder.folder + ' ' + (imgIdx + 1)}
                        style={{ cursor: 'zoom-in' }}
                        onClick={() => handleImgClick(idx, imgIdx)}
                      />
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal for zoom-out effect */}
      {galleryImages.length>0 && <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        contentClassName="modern-gallery-modal-content"
        dialogClassName="modern-gallery-modal-dialog"
      >
        <Modal.Body className="p-0 position-relative bg-transparent">
          <img
            src={`${config.s3.imageUrl}${galleryImages[modalFolderIdx].fileName[modalImgIdx]}`}
            alt="Zoomed"
            className={`modern-gallery-modal-img${zoomOut ? ' zoom-out-anim' : ''}`}
            style={{ width: '100%', background: '#fff', borderRadius: '16px' }}
            onClick={() => setShowModal(false)}
          />
          <p>{galleryImages[modalFolderIdx].fileName[modalImgIdx]}</p>
          {/* Left arrow */}
          <Button
            variant="light"
            className="modern-gallery-arrow left"
            onClick={handlePrev}
            style={{ position: 'absolute', top: '50%', left: 10, transform: 'translateY(-50%)', zIndex: 2, borderRadius: '50%' }}
            aria-label="Previous"
          >
            &#8592;
          </Button>
          {/* Right arrow */}
          <Button
            variant="light"
            className="modern-gallery-arrow right"
            onClick={handleNext}
            style={{ position: 'absolute', top: '50%', right: 10, transform: 'translateY(-50%)', zIndex: 2, borderRadius: '50%' }}
            aria-label="Next"
          >
            &#8594;
          </Button>
        </Modal.Body>
      </Modal>}

      <style>{`
        .modern-gallery-title {
          letter-spacing: 1px;
          color: #1a2740;
          font-size: 2.2rem;
        }
        .modern-gallery-card {
          border-radius: 18px;
          background: #f8fafc;
          transition: box-shadow 0.2s, transform 0.2s;
        }
        .modern-gallery-card:hover {
          box-shadow: 0 6px 32px 0 rgba(44,62,80,0.13);
          transform: translateY(-4px) scale(1.02);
        }
        .modern-gallery-folder {
          color: #2c3e50;
          font-size: 1.2rem;
          letter-spacing: 0.5px;
        }
        .modern-gallery-carousel {
          border-radius: 14px;
          overflow: hidden;
          box-shadow: 0 2px 12px 0 rgba(44,62,80,0.10);
          background: #fff;
        }
        .modern-gallery-carousel .carousel-item {
          height: min(55vh, 420px);
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .modern-gallery-img {
          object-fit: contain;
          height: 100%;
          max-height: 100%;
          border-radius: 14px;
          transition: transform 0.3s;
          background: #fff;
        }
        .modern-gallery-img:hover {
          transform: scale(1.04);
        }
        .modern-gallery-modal-dialog {
          max-width: 700px;
        }
        .modern-gallery-modal-content {
          background: transparent;
          border: none;
          box-shadow: none;
        }
        .modern-gallery-modal-img {
          width: 100%;
          max-height: min(80vh, 760px);
          object-fit: contain;
          transition: transform 0.35s cubic-bezier(.4,2,.6,1), box-shadow 0.2s;
          box-shadow: 0 8px 32px 0 rgba(44,62,80,0.18);
        }
        .zoom-out-anim {
          transform: scale(0.7);
          animation: zoomOutAnim 0.35s cubic-bezier(.4,2,.6,1);
        }
        @keyframes zoomOutAnim {
          0% { transform: scale(1.2); }
          100% { transform: scale(0.7); }
        }
        .modern-gallery-arrow {
          font-size: 2rem;
          opacity: 0.85;
          background: #fff !important;
          box-shadow: 0 2px 8px 0 rgba(44,62,80,0.13);
          border: none;
        }
        .modern-gallery-arrow:hover {
          opacity: 1;
          background: #f0f4fa !important;
        }
        @media (max-width: 991.98px) {
          .modern-gallery-carousel .carousel-item {
            height: min(50vh, 360px);
          }
          .modern-gallery-modal-dialog {
            max-width: 95vw;
          }
        }
        @media (max-width: 767.98px) {
          .modern-gallery-title {
            font-size: 1.5rem;
          }
          .modern-gallery-carousel .carousel-item {
            height: min(45vh, 300px);
          }
          .modern-gallery-modal-img {
            max-height: min(70vh, 560px);
          }
        }
      `}</style>
    </div>
  );
}
